import { APIClient, ApiQueryParams } from '@frontend/api-utils';
import {
    CreateReviewTransaction,
    IReviewTransaction,
    ReviewTransactionListResponse,
    ReviewTransactionQueryParams,
    UpdateReviewTransaction
} from '@frontend/review/types';

export class ReviewTransactionClient extends APIClient {
    public static readonly endpoint = '/review-api/v1';

    public static async fetchReviewTransactions(queryParams?: ApiQueryParams<ReviewTransactionQueryParams>): Promise<ReviewTransactionListResponse> {
        return await this.apiPaginated<ReviewTransactionListResponse, ReviewTransactionQueryParams>(`${this.endpoint}/review-transactions`, queryParams);
    }

    public static async resolveReviewTransactions(ids: string[]): Promise<ReviewTransactionListResponse> {
        const response = await this.post(`${this.endpoint}/review-transactions-resolve`, { ids: ids });
        return await this.handleResponse<ReviewTransactionListResponse>(response);
    }

    public static async deleteReviewTransactions(ids: string[]): Promise<void> {
        const response = await this.post(`${this.endpoint}/review-transactions-delete`, { ids: ids });
        return await this.handleVoidResponse(response);
    }

    public static async createReviewTransaction(accountId: string, reviewId: string, body: CreateReviewTransaction): Promise<IReviewTransaction> {
        const response = await this.post(`${this.endpoint}/accounts/${accountId}/reviews/${reviewId}/review-transactions`, body);
        return await this.handleResponse<IReviewTransaction>(response);
    }

    public static async fetchReviewTransaction(accountId: string, reviewId: string, reviewTransactionId: string): Promise<IReviewTransaction> {
        const response = await this.fetch(`${this.endpoint}/accounts/${accountId}/reviews/${reviewId}/review-transactions/${reviewTransactionId}`);
        return await this.handleResponse<IReviewTransaction>(response);
    }

    public static async patchReviewTransaction(
        accountId: string,
        reviewId: string,
        reviewTransactionId: string,
        body: UpdateReviewTransaction
    ): Promise<IReviewTransaction> {
        const response = await this.patch(`${this.endpoint}/accounts/${accountId}/reviews/${reviewId}/review-transactions/${reviewTransactionId}`, body);
        return await this.handleResponse<IReviewTransaction>(response);
    }

    public static async deleteReviewTransaction(accountId: string, reviewId: string, reviewTransactionId: string): Promise<void> {
        const response = await this.delete(`${this.endpoint}/accounts/${accountId}/reviews/${reviewId}/review-transactions/${reviewTransactionId}`);
        return await this.handleVoidResponse(response);
    }
}
